/*
 * @Author: Merlin
 * @Date: 2025-06-23 13:33:20
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-14 13:36:15
 * @Description: 
 */

import { useJoinStateStore } from '@/stores/cansino/joinState';
import { useUserStore } from '~/stores/user';
// import moment from 'moment';


export type PacketQty = 5 | 8 | 10;  
export type RunningType = 'sending' | 'collecting';

// export const oNumIcon = { // 仅用于调试 
//     '5': '5️⃣',
//     '8': '8️⃣',
//     '10': '🔟',
// };

export enum ActionInt {
    sending = 1, // 发包=1
    collecting = 2,
};

interface PacketOption {
    value: PacketQty;
    checked: boolean;
    aList: Array<Object>; 
}

// 红包选项     
export const aPartitionPlans:PacketOption[]  = [{
    value: 5, // 拆分方案 
    checked: false,
    aList: [],
},{
    value: 8,
    checked: false,
    aList: [],
},{
    value: 10,
    checked: false,
    aList: [],
},]

export const aPartitionPlanArr:PacketQty[] = aPartitionPlans.map((item) => {
    return item.value; 
});


// 拿取各个厅的封面图
export const fnGetCoverPics = () => {
    const oPics = import.meta.glob('../img/hall-cover/*.webp', {
        eager: true,
    });

    const aList = Object.entries(oPics).map(([key, value]) => {
        const sLongName = key.split('/').pop();
        const iPointIdx = sLongName.lastIndexOf('.');
        return [
            sLongName.slice(0, iPointIdx),
            (value as { default: any }).default,
        ];
    });

    const oResult = Object.fromEntries(aList);
    return oResult;
};

// ↓ 大厅列表 
export const getHallsList = ()=>{
    if (import.meta.server) return []; 
    const joinStateStore = useJoinStateStore();  
    const userStore = useUserStore();
    const {t: $tFn} = useNuxtApp().$i18n;
    const arr = joinStateStore.config.tableList || [];
    // 拆分方案 5、8、10 对应的倍数从 rate 属性下取 
    arr.sort((aa, bb)=>{
        const v01 = Number(aa.base);
        const v02 = Number(bb.base);
        return v01 - v02; // 升序 
    });
    arr.forEach((cur, idx)=>{
        cur.intLevel = idx + 1;
        cur.myTitle = $tFn(`redPacketMines.hall0${cur.intLevel}`);
        cur.disabled = (
            Number(userStore.oNowCurrency.balance)
            < Number(cur.base)
        );
    });
    return arr;
}

// ↓ 跳转到游戏入口页 
export const fnGoToEntrance = (
    oConfig={},
)=>{
    const path = `/casino/redpacketGame/entrance`; 
    useRouter().push({
        path: getLocalPath(path),
        replace: true, // 默认不生成历史记录  
        ...oConfig,
    });
}


// ↓ 进入某个厅的方法  
export const fnGoIntoOneHall = (
    oOneHall,
    oConfig={},
)=>{
    if (oOneHall['disabled'] === true){
        showNegativeNotify({
            i18n: 'redPacketMines.lowBalance',
        }); 
        return;
    }
    // oHall ||= this.getHall();
    const path = `/casino/redpacketGame/indoor/${oOneHall.id}`; 
    useRouter().push({
        path: getLocalPath(path),
        // replace: true, // 不生成历史记录 
        ...oConfig,
    });
}



export const fnOperateHistoryDetail = (
    oHistory, 
)=>{
    // const {t: $tFn, locale} = useNuxtApp().$i18n;
    const {
        playerId,
        groupId,
        senderInfo,
        history_detail_list,
    } = oHistory;
    if (!playerId){
        console.error('红包游戏缺失 playerId', playerId); 
    }
    const aAmountList = history_detail_list.map(cur=>{
        return cur.win_amount;
    });
    senderInfo.timestamp *= 1000;
    // ↓ 最大获奖金额 
    const iBiggestAmount = Math.max(...aAmountList); 
    // ↓ 追加抢包信息 
    const history_detail_list_new = history_detail_list.map(cur => {
        const {win_amount, winAmountAfterTax} = cur;
        const thisOne = {
            ...cur,
            timestamp: cur.timestamp * 1000,
            isChampion: (win_amount > 0) && (win_amount == iBiggestAmount), 
            // ↓ 赢时才有前值 || 输时取后值（负数） 
            // ↓ 用于游戏历史的详情窗口 
            winAmountFinal: winAmountAfterTax || win_amount,
        };
        return thisOne;
    });
    const oResult = { // 先声明，后赋值 
        _id: '',
        timestamp: 0,
        "amount": 0,
        "winAmount": 0,
        "multi": 0,
        "currency": oHistory.currency,
        senderInfo,
        history_detail_list: history_detail_list_new, 
        "user": {
            "_id": 0,
            "avatar": "",
            "lvl": 1,
            "name": "",
        },
    };

    if (String(senderInfo.send_user_id) == String(playerId)){ // 当前用户是发包人  
        Object.assign(oResult, {
            _id: senderInfo.orderId,
            timestamp: senderInfo.timestamp,
            amount: senderInfo.amount,
            winAmount: senderInfo.winAmount,
            multi: senderInfo.winAmount > 0 ? senderInfo.multi : 0, 
            user: {
                // "lvl": senderInfo.lvl || 1,
                "_id": senderInfo.send_user_id,
                "avatar": senderInfo.send_user_avatar,
                "name": senderInfo.send_name,
            },
        }); 
    }else{
        const oSelf = history_detail_list_new.find(cur => { 
            return playerId == cur.user_id; 
        }) || {};
        Object.assign(oResult, {
            _id: oSelf.orderId,
            timestamp: oSelf.timestamp,
            winAmount: oSelf.win_amount,
            user: {
                "_id": oSelf.user_id,
                "avatar": oSelf.user_avatar,
                "name": oSelf.user_name,
            },
        }); 
    }
    return oResult;
};

// ↓ 抢包后返回内容 
const GameResult = ({
    "game": { "_id": 21 }, 
    "user": {
        "_id": 0, // 70 
        "address": "",
        "avatar": "", // defaultAvatarName:male_05
        "lvl": 1,
        "name": "", // User002x70 
    },
    "amount": 0,
    "action": 0,
    "count": 0,
    "rate": 0,
    "num": 0,
    "isMine": 0,
    "Mine": 1, // 
    "balanceBefore": 0,
    "currency": "cny",
    "roundNum": 0,
    "timestamp": '', // "2025-07-18T05:55:35Z",
    "winAmount": 0, // 1.23
    "tax": 0, // 0.00615
    "taxWinAmount": 0, // 1.22385
    "difference": 0,
    "confirmed": false,
    "minedTokens": 0,
    "rateToBTC": 0,
    "rateToUSD": 0,
    "_id": "", // 25071813553586988694
    "hid": 0, // 4882
    "combo": 0, // 用户抢包连赢次数 
});


export type GameResultType = Partial<typeof GameResult>;

